@use '../../style/mixins';
@use '../../style/internal/shared_input-select-picker';
@import './partial-styles/lime-admin-hack';

:host {
    position: relative;
    --popover-surface-width: 50rem;
}

.color-picker {
    display: grid;
    gap: 0.25rem;
    grid-template-columns: auto 1fr;
}

.picker-trigger {
    all: unset;
    border-radius: 0.5rem;
    @include mixins.is-elevated-clickable();
    @include mixins.visualize-keyboard-focus();

    &:after {
        box-shadow: 0 0 0 0.25rem rgb(var(--contrast-100)) inset;
    }
}

.chosen-color-preview,
.picker-trigger {
    box-sizing: border-box;
    position: relative;
    isolation: isolate;
    width: shared_input-select-picker.$height-of-mdc-text-field;
    height: shared_input-select-picker.$height-of-mdc-text-field;

    &:before,
    &:after {
        content: '';
        position: absolute;
        inset: 0;
        border-radius: inherit;
    }

    &:before {
        @include mixins.add-chessboard-background();
        z-index: 0;
    }

    &:after {
        background: var(--background);
        z-index: 1;
    }
}

:host([readonly]) {
    .picker-trigger {
        &:hover,
        &:active {
            cursor: default;
            box-shadow: var(--button-shadow-normal);
            transform: none;
        }
    }
}

.chosen-color-input[readonly] {
    transform: translateX(
            calc(
                #{shared_input-select-picker.$height-of-mdc-text-field} / 4 * -1
            )
        )
        translateY(
            calc(#{shared_input-select-picker.$height-of-mdc-text-field} / 4)
        );
}
